import script from "./FuelReportDocument.vue?vue&type=script&setup=true&lang=js"
export * from "./FuelReportDocument.vue?vue&type=script&setup=true&lang=js"

import "./FuelReportDocument.vue?vue&type=style&index=0&id=feb65a66&lang=css"

const __exports__ = script;

export default __exports__